import { useState } from 'react'
import { AlertPanel } from '../components/AlertPanel'
import { useAdminData } from '../hooks/useAdminData'
import { api } from '../../api/client'

interface AlertsData {
  alerts: Array<{
    id: string
    alert_type: string
    severity: string
    title: string
    description?: string
    resolved: boolean
    resolved_at?: string
    created_at: string
  }>
  total_count: number
}

export function AlertsPage() {
  const [showResolved, setShowResolved] = useState(false)
  const { data, loading, refetch } = useAdminData<AlertsData>(
    `/alerts?resolved=${showResolved}`,
    [showResolved],
  )

  const handleResolve = async (id: string) => {
    await api.patch(`/admin/alerts/${id}/resolve`, {})
    refetch()
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1
          style={{
            fontFamily: 'var(--serif)',
            fontSize: '28px',
            fontWeight: 600,
            color: 'var(--ink)',
            margin: 0,
          }}
        >
          Alertas
        </h1>
        <div style={{ display: 'flex', gap: '4px' }}>
          <button
            onClick={() => setShowResolved(false)}
            style={{
              padding: '6px 14px',
              borderRadius: '8px',
              border: '1px solid var(--border)',
              background: !showResolved ? 'var(--ink)' : 'transparent',
              color: !showResolved ? '#fff' : 'var(--ink-light)',
              fontFamily: 'var(--sans)',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Activos
          </button>
          <button
            onClick={() => setShowResolved(true)}
            style={{
              padding: '6px 14px',
              borderRadius: '8px',
              border: '1px solid var(--border)',
              background: showResolved ? 'var(--ink)' : 'transparent',
              color: showResolved ? '#fff' : 'var(--ink-light)',
              fontFamily: 'var(--sans)',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Resolvidos
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '48px', textAlign: 'center', color: 'var(--ink-muted)', fontFamily: 'var(--sans)' }}>
          A carregar...
        </div>
      ) : (
        <>
          <div
            style={{
              fontFamily: 'var(--sans)',
              fontSize: '13px',
              color: 'var(--ink-muted)',
            }}
          >
            {data?.total_count || 0} alerta(s) {showResolved ? 'resolvido(s)' : 'activo(s)'}
          </div>
          <AlertPanel
            alerts={data?.alerts || []}
            onResolve={!showResolved ? handleResolve : undefined}
          />
        </>
      )}
    </div>
  )
}
